var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrandMetaFacebookStyleBlack = function SvgBrandMetaFacebookStyleBlack(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg_icon_BrandMetaFacebookStyleBlack__clip0_1439_24010)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M24 12.073C24 5.405 18.628 0 12 0S0 5.405 0 12.073C0 18.1 4.387 23.094 10.125 24v-8.437H7.078v-3.491h3.047v-2.66c0-3.025 1.791-4.697 4.533-4.697 1.312 0 2.686.236 2.686.236v2.971H15.83c-1.49 0-1.955.932-1.955 1.887v2.264h3.328l-.532 3.49h-2.796V24C19.613 23.094 24 18.1 24 12.073"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "svg_icon_BrandMetaFacebookStyleBlack__clip0_1439_24010"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrandMetaFacebookStyleBlack);
export { ForwardRef as ReactComponent };